import React from "react"
import { HighlightItem, Container, FeatureHighLightImage, Text } from "./styles"

const FeatureHighlights = ({ highlights = [] }) => (
  <Container>
    {highlights.map((highlight, index) => (
      <HighlightItem key={highlight.id || index}>
        <FeatureHighLightImage
          alt={highlight.value}
          src={highlight.image[0]?.secure_url}
          width={highlight.image[0]?.width}
          height={highlight.image[0]?.height}
        />
        <Text>{highlight.value}</Text>
      </HighlightItem>
    ))}
  </Container>
)

export default FeatureHighlights
